import { Typography, InputAdornment, TextField, Paper, Snackbar, makeStyles, Tabs, Tab } from '@material-ui/core'
import React, { useEffect, useReducer, useState } from 'react'
import ic_search from '../../assets/ic_search.png';
import CloseIcon from '@material-ui/icons/Close';
import api from '../api'
import MuiAlert from '@material-ui/lab/Alert';
import SearchComponent from '../components/search/SearchComponent'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function CatatanDokter(props) {
    const [listDokter, setListDokter] = useState([])
    const [visibleSearch, setVisibleSearch] = React.useState(false)
    const [loading, setLoading] = React.useState(false);
    const [selectedData, setSelectedData] = React.useState(null);
    const [value, setValue] = React.useState(null);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const classes = useStyles()
    const [listPoli, setListPoli] = React.useState([]);
    const [valueID, setValueID] = React.useState(0);
    const [doctor_detail_id, set_doctor_detail_id] = React.useState(0)

    const forceUpdate = useReducer(bool => !bool)[1];

    useEffect(() => {
        getAllDokter()
    }, [])

    const handleChange = (event, idx) => {
        console.log(event);
        setValue(event)
        setValueID(event.polyclinic_id)
    };

    const getAllDokter = () => {
        api.create().getListDokter().then(response => {
            console.log(response, props);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item) => {
                        if (item.deleted_at === null) {
                            data.push(item)
                        }
                    })
                    setListDokter(data)
                }
            }
        })
    }

    const doFilter = (keyword) => {
        let param = `keyword=${keyword}`
        if (keyword === null || keyword === "") {
            getAllDokter()
        } else {
            api.create().getListDokterFilter(param).then(response => {
                console.log(response)
                if (response.data) {
                    if (response.data.status === true) {
                        let data = []
                        response.data.data.map((item) => {
                            if (item.deleted_at === null) {
                                data.push(item)
                            }
                        })
                        setListDokter(data)
                    } else {
                        setListDokter([])
                    }
                }
                setLoading(false)
            })
        }
    }

    const handleClick = (item) => {
        setSelectedData(item)
        getDetailDokter(item)
    }

    const getDetailDokter = (e) => {
        api.create().getDetailDokter(e.id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data[0]
                        let poli = []
                        data.polyclinic && data.polyclinic.map((item) => {
                            if (item.deleted_at === null) {
                                poli.push(item)
                            }
                        })
                        console.log(poli);
                        if (poli.length > 0) {
                            setValueID(poli[0].doctor_detail_id)
                            setValue(poli[0])
                            setListPoli(poli)
                        }
                        if (value) {
                            set_doctor_detail_id(value.doctor_detail_id)
                        }
                    }
                }
            }
        })
    }

    const handleSave = (item) => {
        let payload = {
            "id": item.doctor_detail_id,
            "notes": item.notes
        }
        api.create().updateCatatanDokter(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ width: '25%', maxHeight: props.height - 100, overflow: 'scroll' }}>
                <Typography style={{ color: '#278863', marginTop: 20 }}>List Nama Dokter</Typography>
                <hr style={{ marginTop: 0 }} />
                {
                    !visibleSearch ?
                        <img title="Cari Dokter" onClick={() => setVisibleSearch(true)} src={ic_search} style={{ marginBottom: 10, cursor: 'pointer' }} />
                        :
                        <SearchComponent
                            placeholder={"Input Nama Dokter"}
                            onSearch={(val)=>{doFilter(val)}}
                            onDelete={()=>{
                                doFilter(null)
                                setVisibleSearch(false)
                            }}
                        /> 
                }
                {listDokter.length > 0 && listDokter.map((item, index) => {
                    return (
                        <div style={{ cursor: "pointer", margin: '5px 0' }}
                            onClick={() => {
                                handleClick(item)

                            }}>
                            <Typography style={{ color: selectedData && selectedData.id === item.id ? '#278863' : '#b4b4b4' }}>{item.name}</Typography>
                        </div>
                    )
                })}
            </div>
            <div style={{ width: '70%', margin: 10 }}>
                <div style={{ display: 'flex' }}>
                    {
                        listPoli.length > 0 && listPoli.map((el, idx) => {
                            // console.log(el);
                            el["no"] = idx + 1
                            // no.map((item, id) => {
                            //     item["no"] = id + 1
                            // })
                            return (
                                <Tabs
                                    value={el.id}
                                    indicatorColor="primary"
                                    textColor="#2a9c6c"
                                    onChange={() => handleChange(el)}
                                    aria-label="disabled tabs example"
                                    style={{ outline: 'null', display: 'flex' }}
                                    classes={{ indicator: classes.tabsIndicator }}
                                >
                                    <Tab label={`Klinik ${el.name}`} style={{ color: value == el ? '#2a9c6c' : 'black', borderBottom: value == el ? '3px solid #2a9c6c' : null, borderBottomWidth: "5%" }} />
                                </Tabs>
                            )
                        })
                    }
                </div>

                {value && (
                    <Paper style={{ width: '100%', height: props.height - 150, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)', padding: 20, maxHeight: props.height - 100, overflow: 'scroll' }}>
                        <div style={{}}>
                            <textarea
                                value={value.notes === null ? "" : value.notes}
                                onChange={(e) => {
                                    value.notes = e.target.value
                                    forceUpdate()
                                }}

                                style={{ width: '100%', marginTop: 10, minHeight: 200 }}
                                placeholder={"input catatan"}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                        style={{ backgroundColor: 'transparent', border: 'transparent', borderColor: 'transparent', outline: 'none' }}
                                        onClick={() => handleSave(value)}
                                    >
                                        <div style={{ display: 'flex', backgroundColor: '#2a9c6c', borderRadius: 70, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2px 10px' }}>
                                            <Typography style={{ fontSize: 12, color: 'white' }}>Simpan</Typography>
                                        </div>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </Paper>
                )}
            </div>
        </div>
    )
}